import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=5d2781e2&scoped=true&"
import script from "./FormTextarea.vue?vue&type=script&lang=js&"
export * from "./FormTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FormTextarea.vue?vue&type=style&index=0&id=5d2781e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2781e2",
  null
  
)

export default component.exports